var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 64,
    viewBox: "0 0 83 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C23.3395 17.0657 51.7469 27.2959 82.2857 27.8717C65.7328 36.5723 47.3981 42.1278 28.0049 43.7858L0 0Z",
    fill: "url(#paint0_linear_291_1232)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.978 46.8712L40.9333 64L57.506 41.4102C48.5265 44.0648 39.3134 45.868 29.978 46.8712Z",
    fill: "url(#paint1_linear_291_1232)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3948 23.8416L81.8662 8.20517L81.8538 8.20392C72.9205 13.4379 63.4132 17.7333 53.4551 20.9619C59.0294 22.2687 64.6852 23.233 70.3948 23.8416Z",
    fill: "url(#paint2_linear_291_1232)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_291_1232",
    x1: -0.0765624,
    y1: 15.5116,
    x2: 60.6797,
    y2: 74.0327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE01D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_291_1232",
    x1: -0.0765624,
    y1: 15.5116,
    x2: 60.6797,
    y2: 74.0327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE01D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_291_1232",
    x1: -0.0765624,
    y1: 15.5116,
    x2: 60.6797,
    y2: 74.0327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE01D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new-logo.ed28840da08e0636d4b0ed591d1b22d9.svg";
export { ForwardRef as ReactComponent };